import React, { useEffect } from "react";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";
import ReactApexChart from "react-apexcharts";
import moment from "moment";
import { formatTime } from "../../../Components/Common/processingTime";

export const OrderStats = ({ dataColors, stats }) => {
  // Extract data from stats prop
  const categories =
    stats?.map((item) => moment(item.day).format("DD/MM")) || [];
  const ordersData = stats?.map((item) => item.orders) || [];
  const deliveredData = stats?.map((item) => item.delivered) || [];
  const canceledData = stats?.map((item) => item.canceled) || [];

  var DashedLineColors = getChartColorsArray(dataColors);

  var series = [
    {
      name: "Orders",
      data: ordersData,
    },
    {
      name: "Delivered",
      data: deliveredData,
    },
    {
      name: "Canceled",
      data: canceledData,
    },
  ];

  var options = {
    chart: {
      height: 380,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: DashedLineColors,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3, 4, 3],
      curve: "straight",
      dashArray: [0, 8, 5],
    },
    title: {
      text: "Selected Orders",
      align: "left",
      style: {
        fontWeight: 500,
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: categories,
    },
    // tooltip: {
    //   y: [
    //     // {
    //     //   title: {
    //     //     formatter: function (val) {
    //     //       return val + " orders";
    //     //     },
    //     //   },
    //     // },
    //     // {
    //     //   title: {
    //     //     formatter: function (val) {
    //     //       return val + " delivered";
    //     //     },
    //     //   },
    //     // },
    //     // {
    //     //   title: {
    //     //     formatter: function (val) {
    //     //       return val + " canceled";
    //     //     },
    //     //   },
    //     // },
    //   ],
    // },
    grid: {
      borderColor: "#f1f1f1",
    },
  };

  return (
    <React.Fragment className="">
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="area"
        height="380"
        className="apex-charts w-100"
      />
    </React.Fragment>
  );
};

export const AvgDeliveryTimeChart = ({ dataColors, stats }) => {
  // Extract data from stats prop
  const categories =
    stats?.map((item) => moment(item.day).format("DD/MM")) || [];

  const deliveryTimes = stats?.map((item) => item?.avgDeliveryTime) || [];

  var DashedLineColors = getChartColorsArray(dataColors);

  var series = [
    {
      name: "Avg Delivery Time",
      data: deliveryTimes,
    },
  ];

  var options = {
    chart: {
      height: 380,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: DashedLineColors,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3, 4, 3],
      curve: "straight",
      dashArray: [0, 8, 5],
    },
    title: {
      text: "Order Statistics",
      align: "left",
      style: {
        fontWeight: 500,
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      categories: categories,
    },
    tooltip: {
      y: {
        formatter: function (val, { seriesIndex, dataPointIndex, w }) {
          const label = w.globals.labels[dataPointIndex];
          return `${val} min`; // Only shows label & value
        },
        title: {
          formatter: () => "", // Removes "series-1" title
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  };

  return (
    <React.Fragment className="">
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="line"
        height="380"
        className="apex-charts w-100"
      />
    </React.Fragment>
  );
};

export const DeliveryTime = ({ dataColors, deliveryTimes, canceledTimes }) => {
  var ZoomableTimeseriesColors = getChartColorsArray(dataColors);
  const series = [
    {
      name: "Delivery Time",
      data: deliveryTimes,
    },
    {
      name: "Cancellation Time",
      data: canceledTimes,
    },
  ];
  var options = {
    chart: {
      type: "area",
      stacked: false,
      height: 350,
      zoom: {
        type: "x",
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    },
    title: {
      text: "Order Time Flow (Minutes)",
      align: "left",
      style: {
        fontWeight: 500,
      },
    },
    colors: ZoomableTimeseriesColors,
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    yaxis: {
      showAlways: true,
      labels: {
        show: true,
        formatter: function (val) {
          return (val / 60).toFixed(0);
        },
      },
    },
    xaxis: {
      type: "datetime",
    },
    tooltip: {
      shared: false,
      y: {
        formatter: function (val) {
          return `${formatTime(val)}`;
        },
      },
    },
  };
  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        type="area"
        height="350"
        className="apex-charts w-100"
      />
    </React.Fragment>
  );
};
